import { ApplicationConfig, isDevMode, LOCALE_ID, provideZoneChangeDetection } from "@angular/core";
import { provideRouter } from "@angular/router";
import { routes } from "./app.routes";
import { provideAnimations } from "@angular/platform-browser/animations";
import { provideAllianzIcons } from "@allianz/ngx-ndbx/icon";
import { provideHttpClient, withInterceptors } from "@angular/common/http";
import { errorInterceptor } from "./interceptors/error.interceptor";
import { NxMessageToastService } from "@allianz/ng-aquila/message";
import { provideTransloco } from "@jsverse/transloco";
import { TranslocoHttpLoaderService } from "./services/transloco-loader.service";
import config from "./model/translaco.config";
import { environment } from "../environments/environment";
import { PAYMENT_PORTAL_API_URL } from "@gsa/payment-card";

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: LOCALE_ID, useValue: TranslocoHttpLoaderService.defaultCultureLang },
    { provide: PAYMENT_PORTAL_API_URL, useValue: `${environment.baseUrl}/${environment.paymentPortalApiUrl}` },
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimations(),
    provideAllianzIcons(),
    provideHttpClient(withInterceptors([errorInterceptor])),
    { provide: NxMessageToastService, useClass: NxMessageToastService },
    provideTransloco({
      config: {
        availableLangs: config.langs,
        defaultLang: TranslocoHttpLoaderService.defaultCultureLang,
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
      },
      loader: TranslocoHttpLoaderService,
    }),
  ]
};
